const VideosTechHouse = [
  {
    video_id: "1vTqW-BPFa8",
    title: "Calabria (Claptone Remix)",
    artist: "Claptone, Rune",
  },
  {
    video_id: "-6qeDAz5JhA",
    title: "Dos Mojitos Des Bitte",
    artist: "Alexis Cabrera & Guti",
  },
  {
    video_id: "XUeI5Y9nka0",
    title: "Agboju",
    artist: "Dancing People",
  },
  {
    video_id: "Z5cunMkA4bk",
    title: "Retrovision",
    artist: "Kevin Over",
  },
  {
    video_id: "noqmLzysTdY",
    title: "Words Gone (Jamie Jones remix)",
    artist: "Popof Feat. Arno Joey",
  },
  {
    video_id: "Fk-y83elSBk",
    title: "Urban Photo (Joshua Puerta Remix)",
    artist: "Trouble Makers",
  },
  {
    video_id: "6gN2phyAQ8Y",
    title: "Denney",
    artist: "Low Frequency",
  },
  {
    video_id: "znBwhr1LtwU",
    title: "La Llorona",
    artist: "Mirco Caruso",
  },
  {
    video_id: "QfTqPn84imk",
    title: "Take Some House (Riva Starr Edit)",
    artist: "Paul C & Paolo Martini ft. Roland Clark",
  },
  {
    video_id: "QY3lNSeMCek",
    title: "The Bumps (Pleasurekraft Remix)",
    artist: "John Monkman & Pete Tong",
  },
  {
    video_id: "Vr2aGTm2U5A",
    title: "Sweet Love",
    artist: "Luca M & JUST2",
  },
  {
    video_id: "gSD9WyXE-VY",
    title: "Also! (2015 Rework)",
    artist: "Ruben Mandolini",
  },
  {
    video_id: "mHDwjhnpGlA",
    title: "Breathe",
    artist: "Brett Johnson",
  },
  {
    video_id: "ZPlauvnyGpE",
    title: "Triptiko (Original Mix)",
    artist: "Wes Yvaez",
  },
  {
    video_id: "dEdyhnN0OyU",
    title: "Transmission",
    artist: "Mirco Caruso",
  },
  {
    video_id: "ITpOMvP9yEU",
    title: "Feelings & Meanings",
    artist: "Josh Butler",
  },
  {
    video_id: "patBYdLMc8M",
    title: "Oregon",
    artist: "Kaiserdisco",
  },
  {
    video_id: "9rvB1OU5F60",
    title: "Watcha Gonna Do",
    artist: "Wade",
  },
  {
    video_id: "mGpTh7IANGU",
    title: "Potty",
    artist: "Rampa",
  },
  {
    video_id: "nZnIq5U63Mw",
    title: "Dejected (Paul C & Paolo Martini Remix)",
    artist: "Astin",
  },
  {
    video_id: "rauJ6ISPRZE",
    title: "Til Tomorrow",
    artist: "Ten Story",
  },
  {
    video_id: "n1rsh3pBfZg",
    title: "Jack To Jack",
    artist: "Prok & Fitch",
  },
  {
    video_id: "YC2KQf3n64Y",
    title: "Mod",
    artist: "Rampa",
  },
  {
    video_id: "4dGbDPZ3Ezc",
    title: "Cold Sweat",
    artist: "Emanuel Satie",
  },
  {
    video_id: "Hy5v3BPjXlk",
    title: "Once And For All",
    artist: "Rene Amesz & Camilo Franco",
  },
  {
    video_id: "E3t2CoRR90M",
    title: "Magic Flight",
    artist: "Lauren Lane",
  },
  {
    video_id: "04JZKwguVoA",
    title: "Trucco",
    artist: "Wade",
  },
  {
    video_id: "LBj3iGImm2s",
    title: "Personal Question",
    artist: "Bontan",
  },
  {
    video_id: "1zzLjFFH-H4",
    title: "Planet Rock (Claptone Remix)",
    artist: "Powers That Be vs Roland Clark",
  },
  {
    video_id: "05SQP726-WY",
    title: "Ya!",
    artist: "Oscar L",
  },
  {
    video_id: "qVeixkNxMaI",
    title: "Vicious Circle",
    artist: "Larry Cadge",
  },
  {
    video_id: "fjvf_7ekc2Y",
    title: "La Fiesta",
    artist: "Avermass",
  },
  {
    video_id: "IHFSML5-irU",
    title: "Funky Child",
    artist: "De La Maso, Marco Zorano & Dexxis",
  },
  {
    video_id: "Ck2gEEIEbyU",
    title: "Thang",
    artist: "Doorly",
  },
  {
    video_id: "2b0LlYILqzE",
    title: "Kommissar",
    artist: "Tony Guerra",
  },
  {
    video_id: "lYu8_97Jp7g",
    title: "Jupiter Rising",
    artist: "Kydus",
  },
  {
    video_id: "NhHtSDGbwPY",
    title: "Cygnus",
    artist: "Coyu & Sezer Uysal",
  },
  {
    video_id: "_4xo70Kg4YU",
    title: "EXpand (Tale Of Us Remix)",
    artist: "Plastikman",
  },
  {
    video_id: "nN-SGlZBZ_E",
    title: "Luna",
    artist: "CamelPhat",
  },
  {
    video_id: "PCXUIVXnsnA",
    title: "Tana (Rub A Dubs 900 Miles Of Sub Remix)",
    artist: "Kydus",
  },
  {
    video_id: "UiNaz80moBo",
    title: "Recreation",
    artist: "Mario Ochoa",
  },
];

export default VideosTechHouse;
